import Step from "./Step";

export default { Template: Step };
